@if (isLoaded && hasAlerts) {
  <div [style.background-color]="backgroundColor | HexToHsl" (click)="onClick()"
    class="shadow-lg rounded-xl w-full relative overflow-hidden h-12 flex items-center justify-between cursor-pointer">
    <vw-chevron-right-icon
      [style.color]="textColor"
      class="transition-transform duration-300 absolute right-3 top-1/2 -translate-y-1/2" />
    <div class="h-full flex items-center px-4 gap-2">
      <div class="w-8 flex items-center justify-center shrink-0 h-5">
        <vw-bell-icon [style.color]="textColor" class="h-5" />
      </div>
      <p class="text-sm font-medium whitespace-normal" [style.color]="textColor">
        {{ urgentCount }}
        {{ (urgentCount === 1 ? 'alerts.banner.single' : 'alerts.banner.multiple') | translate }}
      </p>
    </div>
  </div>
}
